import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useAPISpoolPriceFeed from '../../../../hooks/web3/general/useAPISpoolPrice';
import useClaimableStakingRewards from '../../../../hooks/web3/vault/useClaimableStakingRewards';
import useClaimedStakingRewards from '../../../../hooks/web3/vault/useClaimedStakingRewards';

const StakingEmissionsToDate: React.FC = () => {
    const { claimableStakingRewards } = useClaimableStakingRewards();
    const { claimedStakingRewards } = useClaimedStakingRewards();
    const { apiSpoolPriceFeed } = useAPISpoolPriceFeed();

    const claimableSpoolAmount = claimableStakingRewards?.spoolRewards['SPOOL'] ?? 0;
    const claimableVoSpoolAmount = claimableStakingRewards?.voSpoolRewards['SPOOL'] ?? 0;

    const claimedSpoolAmount = claimedStakingRewards?.spoolRewards['SPOOL'] ?? 0;
    const claimedVoSpoolAmount = claimedStakingRewards?.voSpoolRewards['SPOOL'] ?? 0;

    const total =
        claimableSpoolAmount +
        claimableVoSpoolAmount +
        claimedSpoolAmount +
        claimedVoSpoolAmount;

    return (
        <Detail
            title={
                <>
                    <span>Your Emission/Epoch Rewards to Date</span>
                    <InfoPopUp>
                        <span>Your Staking Emissions Earned to Date:</span>
                        <div className='mt'>
                            <span className='block'>Claimable Staking Emissions:</span>
                            <strong className='block'>
                                {formatUSD(claimableSpoolAmount || 0)} $SPOOL
                            </strong>
                            <span className='block'>
                                (~$
                                {apiSpoolPriceFeed
                                    ? formatUSD(
                                          claimableSpoolAmount * apiSpoolPriceFeed || 0
                                      )
                                    : '0.00'}
                                )
                            </span>
                            <span className='mt block'>Claimable voSPOOL Emissions:</span>
                            <strong className='block'>
                                {formatUSD(claimableVoSpoolAmount || 0)} $SPOOL
                            </strong>
                            <span className='block'>
                                (~$
                                {apiSpoolPriceFeed
                                    ? formatUSD(
                                          claimableVoSpoolAmount * apiSpoolPriceFeed || 0
                                      )
                                    : '0.00'}
                                )
                            </span>
                        </div>
                        <div className='mt border-top'>
                            <span className='block'>Claimed Staking Emissions:</span>
                            <strong className='block'>
                                {formatUSD(claimedSpoolAmount || 0)} $SPOOL
                            </strong>
                            <span className='block'>
                                (~$
                                {apiSpoolPriceFeed
                                    ? formatUSD(
                                          claimedSpoolAmount * apiSpoolPriceFeed || 0
                                      )
                                    : '0.00'}
                                )
                            </span>
                            <span className='mt block'>Claimed voSPOOL Emissions:</span>
                            <strong className='block'>
                                {formatUSD(claimedVoSpoolAmount || 0)} $SPOOL
                            </strong>
                            <span className='block'>
                                (~$
                                {apiSpoolPriceFeed
                                    ? formatUSD(
                                          claimedVoSpoolAmount * apiSpoolPriceFeed || 0
                                      )
                                    : '0.00'}
                                )
                            </span>
                        </div>
                    </InfoPopUp>
                </>
            }
            value={`${formatUSD(total || 0)} $SPOOL`}
        />
    );
};

export default StakingEmissionsToDate;
